var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("q-panel", { staticClass: "login-page" }, [
    _c("div", { staticClass: "login-header" }, [
      _c("img", { attrs: { src: _vm.logo, alt: "Atrvasa", width: "200px" } }),
    ]),
    _vm._v(" "),
    _c("h4", [_vm._v(" REGISTER ")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "login-form" },
      [
        _c(
          "q-form",
          {
            ref: "loginForm",
            attrs: {
              model: _vm.ruleForm,
              rules: _vm.rules,
              "label-position": "right",
              "labq-width": "120px",
            },
          },
          [
            _c(
              "q-form-item",
              { attrs: { prop: "username" } },
              [
                _c("q-input", {
                  attrs: { placeholder: this.$qt("loginPage.username") },
                  model: {
                    value: _vm.ruleForm.username,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "username", $$v)
                    },
                    expression: "ruleForm.username",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-form-item",
              { attrs: { prop: "password" } },
              [
                _c("q-input", {
                  attrs: {
                    type: "password",
                    placeholder: this.$qt("loginPage.password"),
                  },
                  model: {
                    value: _vm.ruleForm.password,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "password", $$v)
                    },
                    expression: "ruleForm.password",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-form-item",
              { attrs: { prop: "phone" } },
              [
                _c("q-input", {
                  attrs: { placeholder: this.$qt("registerPage.phone") },
                  model: {
                    value: _vm.ruleForm.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "phone", $$v)
                    },
                    expression: "ruleForm.phone",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-form-item",
              [
                _c(
                  "q-button",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.register },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(this.$qt("registerPage.register")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }